import Index from './components/index/Index';
import Projects from './components/projects/Projects';
import Teaching from './components/teaching/Teaching';
import Students from './components/students/Students';
import StudentsUfscIndex from './components/students/ufsc/Index';
import Publications from './components/publications/Publications';
import Talks from './components/talks/Talks';
import Resources from './components/resources/Resources';

export const routesConfig = [
  { path: "/", label: "Home", translationKey: "home", component: Index },
  { path: "/publications", label: "Publications", translationKey: "publications", component: Publications },
  { path: "/publications/:id", component: Publications },
  { path: "/talks", label: "Talks", translationKey: "talks", component: Talks },
  { path: "/talks/:id", component: Talks },
  { path: "/projects", label: "Projects", translationKey: "projects", component: Projects },
  { path: "/teaching", label: "Teaching", translationKey: "teaching", component: Teaching },
  { path: "/students", label: "Students", translationKey: "students", component: Students },
  { path: "/students/ufsc", component: StudentsUfscIndex },
  { path: "/resources", label: "Resources", translationKey: "resources", component: Resources },
];
